<template>
  <v-dialog
      v-model="model"
      scrollable
      @click:outside="fecharModal"
      :persistent="persistencia"
      :max-width="maxWidth"
      style="padding: 0">
    <v-card class="card-component">
      <v-toolbar dark color="primary" elevation="0">
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
        <v-spacer/>
        <v-btn class="close__button" text @click="cancelar" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="color: black">
        <div v-if="qrCode" class="container-qr-code">
          <v-img :src="qrCode" alt="QR Code"/>
        </div>
        <div v-if="token" class="container-token" @click="copiarToken">
          <span>Copiar link<v-btn icon><v-icon>content_copy</v-icon></v-btn></span>
        </div>
        <div v-if="dataExpiracao" class="container-tempo">
          <span>Tempo restante</span>
          <contagem-regressiva v-if="dataExpiracao"
                               :dataExpiracao="dataExpiracao"
                               class-name="cronometro-hash-temporario"
                               @cronometroZerado="exibirBotaoGerarToken"
          />
        </div>
        <div v-if="loading" class="container-qr-code">
          <v-progress-circular
              color="primary"
              size="54"
              indeterminate
          />
        </div>
        <div v-if="!qrCode && !loading" class="container-qr-code">
          <label>Não foi possível gerar o QRCode, tente novamente.</label>
        </div>
        <div v-if="btnGerarToken">
          <v-btn block depressed class="primary" @click="gerarQrCode">Gerar QRCode</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QRCode from 'qrcode'
import {actionTypes} from '@/core/constants'
import ContagemRegressiva from '@/views/components/ContagemRegressiva.vue'


export default {
    name: 'QRCodeModalGaleria',
    components: {ContagemRegressiva},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 400
        },
        titulo: {
            type: String,
            default: 'QR Code'
        },
        textoQRCode: {
            type: String,
            default: '/'
        },
        idPaciente: Number,
        gerarToken: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            qrCode: null,
            token: null,
            dataExpiracao: null,
            btnGerarToken: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.gerarQrCode()
    },
    methods: {
        async gerarQrCode() {
            try {
                this.loading = true
                let texto = this.textoQRCode
                if (this.gerarToken && this.idPaciente) {
                    const resposta = await this.$store.dispatch(actionTypes.GALERIA_PACIENTE.GERAR_TOKEN_QR_CODE, this.idPaciente)
                    if (resposta) {
                        texto += resposta.token
                        this.token = texto
                        this.dataExpiracao = resposta.dataHoraExpiracao
                    }
                }
                this.qrCode = await QRCode.toDataURL(texto)
                this.btnGerarToken = false
            } catch (err) {
                this.btnGerarToken = true
                console.log('Falha ao gerar o QRCode da galeria')
                console.error(err)
            } finally {
                this.loading = false
            }
        },
        copiarToken() {
            if (!this.token) return
            navigator.clipboard.writeText(this.token)
                .then(() => {
                    console.log('Token copiado com sucesso!')
                })
                .catch((err) => {
                    console.error('Erro ao copiar token:', err)
                })
        },
        exibirBotaoGerarToken() {
            this.qrCode = null
            this.token = null
            this.dataExpiracao = null
            this.btnGerarToken = true
        },
        fecharModal() {
            if (!this.persistencia) {
                this.cancelar()
            }
        },
        cancelar() {
            this.model = false
            this.$emit('modalQRCodeFechar')
        },
    }

}
</script>

<style scoped lang="stylus">
.card-component
  text-align start
  background-color #FFFFFF
  color #000000

.container-qr-code
  display flex
  justify-content center
  align-items center
  min-height 300px

.container-tempo
  display flex
  flex-direction column
  align-items center
  font-weight bold
  color var(--theme-primary)

.cronometro-hash-temporario
  font-size 24px

.container-token
  background-color #f5f5f5
  border 1px solid #e0e0e0
  border-radius 5px
  padding 1px
  display flex
  flex-direction row
  justify-content center

.container-token:hover
  cursor pointer

</style>